import React, {useEffect, useState} from "react";
import withHeader from "../../hocs/withHeader";
import HelpSection from "./HelpSection";
import ArticlePage from "./ArticlePage";
import SurveysService from "../../../services/SurveysService";
import withFooter from "../../hocs/withFooter";

function HelpPage(props){
	
	const helpCenterSections=[
		{
			title:"How bubblyPolls works",
			description:"Get a glimpse of our online survey solution. Spoiler alert: you have pretty much everything you need in one place, your actionable insights in just a few clicks",
			url:"how-works",
			items:[
				{
					url:"what-is",
					title:"What is bubblyPolls?"
				},
				{
					url:"glossary",
					title:"Glossary"
				}				
			]
		},
		{
			title:"Create and edit surveys",
			description:"All you need to know before getting started on building your survey: how to find the survey template that fits to your needs, what type of questions to use, how to add survey logic and why it’s important to preview your survey before sharing it to your audience",
			url:"create-edit-surveys",
			items:[
				{
					url:"create-survey",
					title:"Create surveys"
				},
				{
					url:"survey-templates",
					title:"Survey templates"
				},
				{
					url:"question-types",
					title:"Question types"
				},
				{
					url:"question-settings",
					title:"Question settings"
				},
				{
					url:"survey-logic",
					title:"Survey logic"
				},
				{
					url:"preview-survey",
					title:"Preview your survey"
				}				
			]
		},
		{
			title:"Share your survey to your audience",
			description:"Learn how to distribute your survey to your audience in order to collect answers",
			url:"share-surveys",
			items:[
				{
					url:"sharing-options",
					title:"Sharing options"
				},
				{
					url:"monitor",
					title:"Monitor survey completition"
				}		
			]
		},
		{
			title:"Analyze survey data",
			description:"A few tips and tricks to make the most of your survey results with bubblyPolls: what the dashboard is about, how to customize the charts, how to export the database and even download full automatic reports. Quite everything you need on the route to actionable insights! ",
			url:"survey-data",
			items:[
				{
					url:"about-dash",
					title:"About the dashboard"
				},
				{
					url:"customize-charts",
					title:"Customize charts"
				},
				{
					url:"report",
					title:"Download report"
				},
				{
					url:"csv",
					title:"Export database"
				},
				{
					url:"spss",
					title:"SPSS syntax"
				}			
			]
		},
		{
			title:"Account & billing",
			description:"Manage your account and subscription plan",
			url:"account",
			items:[
				{
					url:"register",
					title:"Register and login"
				},
				{
					url:"profile",
					title:"Account & profile settings"
				},
				{
					url:"reset",
					title:"Reset password"
				},
				{
					url:"subscription",
					title:"Subscription plan"
				}		
			]
		},
		{
			title:"Legal & security",
			description:"Everything you need to know about your data protection",
			url:"legal",
			items:[
				{
					url:"terms",
					title:"Terms & conditions"
				},
				{
					url:"data-protection",
					title:"Privacy Policy"
				},
				{
					url:"cookie",
					title:"Cookie Policy"
				}		
			]
		},
		{
			title:"FAQ",
			description:"Quick solutions to your specific issues",
			url:"faq",
			items:[
				{
					url:"faq",
					title:"FAQ"
				}	
			]
		}
	];
	
	function pageExists(currentPage, allSections){
		return allSections.map(section => {
			return section.items.map(item  => {return currentPage==section.url+'/'+item.url}).reduce((total,res)=> total|res,false)
		}).reduce((total,res)=> total|res,false);
	}

	function getSectionIfExists(currentSection, allSections){
		return allSections.filter(section  => { return currentSection===section.url})
	}
	function getSectionForPagesIfExists(currentPages, allSections){
		return allSections.map(section  => {
			const cloneSection = { ...section };
			cloneSection.items =  section.items.filter(item  => {return currentPages.includes(item.url)})
			return cloneSection;
		}).filter(section  => {return section.items.length>0})
	}
	
	function onKeyPress(e){
        if (e.key !== "Enter") return;
		let inputText = event.target.value;
		if(inputText===''){
			setSections(helpCenterSections);		
			setOpenSubmenu(false);
			return;			
		}				
		SurveysService.HelpSearch(inputText,
            (success) => {
				setSections(getSectionForPagesIfExists(success.data,helpCenterSections));		
				setOpenSubmenu(true);
			},
            (error) => {}
		);
    }

	let page="";
	if(props.location.pathname.length>12) page = props.location.pathname.substr(13);
	if(page.endsWith('/')) page = page.substr(0,page.length-1);
	
	let initSections = helpCenterSections;
	let initOpenSubmenu = false;
	if(page.length>0){
		if(page.includes('/')){
			if(pageExists(page,helpCenterSections)) return <ArticlePage articleUrl={page}/>;
		}else{
			let urlSection = getSectionIfExists(page,helpCenterSections);
			if(urlSection.length>0){
				initSections = urlSection;
				initOpenSubmenu = true;
			}
		}
	}
	const [ sections, setSections ] = useState(initSections);
	const [ openSubmenu, setOpenSubmenu ] = useState(initOpenSubmenu);

	return (
		<section className="helper">
			<div className="helper__jumbotron">
				<div className="container">
					<h1><span>We are here for you.</span> <span>How can we help?</span></h1>
					<div className="helper__jumbotron__search">
						<input className="helper__jumbotron__search__input" type="text" onKeyPress={onKeyPress} placeholder="Search..."/>
						<span className="helper__jumbotron__search__icon"><img src="./assets/img/build_helper/search.png" alt="" /></span>
					</div>
				</div>
			</div>
			<div className="container">
				<div className="helper__section">
				{
					sections.length==0?
						<div className="helper__section__item">
							<div className="helper__section__item__text" style={{width:'100%', textAlign:'center'}}>
								<div className="helper__section__item__text__title">Try different keywords.</div>
								<div className="helper__section__item__text__description">We could not find any result for this search</div>
							</div>
						</div>:null
				}
				{
					sections.map((section) => {
						return <HelpSection key={section.url} section={section} subMenuOpen={openSubmenu}/>;
					})
				}
				</div>
			</div>
		</section>
	);

}
export default withFooter(withHeader(HelpPage));